export function isModalDemoEnabled() {
  return process.env.NODE_ENV === "development"
}
